import React from 'react'
import { Link } from 'react-router-dom'

import { IoMdCloseCircle } from 'react-icons/io'

const NAV_LINKS = [
  {
    name: 'Features',
    linkPath: '#Features',
  },
  {
    name: 'About',
    linkPath: '#About',
  },
  {
    name: 'Tokenomics',
    linkPath: '#Tokenomics',
  },
  {
    name: 'Roadmap',
    linkPath: '#Roadmap',
  },
]

export default function MobileMenu({ setMenuShow }) {
  const HandleClose = () => {
    setMenuShow(false)
  }

  return (
    <div className='sidebar absolute left-0 top-0 bg-black w-[250px] h-[100vh] text-white py-10 px-5 animation transition-all decoration-slate-200 delay-150'>
      <span
        className='absolute top-5 right-8 bg-white text-black rounded-full p-2'
        onClick={HandleClose}
      >
        <IoMdCloseCircle />
      </span>
      <div>
        <ul className='flex flex-col items-start justify-start gap-10 mt-10'>
          {NAV_LINKS.map((item, index) => (
            <li
              key={index}
              className='font-medium text-2xl'
            >
              <a hrem={item.linkPath}>{item.name}</a>
            </li>
          ))}
        </ul>
        <div className='flex items-center gap-7 my-8'>
          <a href="">
            <img src="images/t.png" alt="" className='w-[15vw]' />
          </a>
          <a href="">
            <img src="images/x.png" alt="" className='w-[15vw]' />
          </a>
        </div>
        <div className=' items-center gap-2'>
          <a href="">
            <button class="btn1 w-full px-14 py-4 rounded-full">Buy Now</button>
          </a>
        </div>
      </div>
    </div>
  )
}
